// Mock data for Creative Minds Art Studio

export const portfolioImages = [
  {
    id: 1,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/boj8vgsp_20260725_185343.webp",
    title: "Creative Chaos - Group Session",
    description: "Three artists creating magic together in protective suits",
    date: "2026-07-25",
    type: "image"
  },
  {
    id: 2,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/to6gdsk2_20260725_190909.webp",
    title: "Paint Splatter Action",
    description: "Artist in full creative flow with vibrant paint explosions",
    date: "2026-07-25",
    type: "image"
  },
  {
    id: 3,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/iclg1yxn_20260725_190913.webp",
    title: "Colorful Canvas Creation",
    description: "Close-up of artwork in progress with paint bottles and creative chaos",
    date: "2026-07-25",
    type: "image"
  },
  {
    id: 4,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/4nj5zcs4_20260725_190925.webp",
    title: "Making Art Magic",
    description: "Artist creating vibrant masterpiece on floor canvas",
    date: "2026-07-25",
    type: "image"
  },
  {
    id: 5,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/0kk62qka_20260725_190930.webp",
    title: "Artistic Expression in Action",
    description: "Final touches on a colorful paint splatter creation",
    date: "2026-07-25",
    type: "image"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/y9nv19we_Thomas%26Stacey.jpg",
    title: "Thomas & Stacey's Creation",
    description: "A beautiful collaborative masterpiece",
    date: "2026-03-30",
    type: "image"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/igfcjnes_20260321_174942.jpg",
    title: "Creative Expression in Action",
    description: "Unleashing creativity through paint",
    date: "2026-03-21",
    type: "image"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/rswm8eih_20260411_150305.jpg",
    title: "Kids Creative Session",
    description: "Young artists with their colorful creations",
    date: "2026-04-11",
    type: "image"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/qaw9moy5_20260411_150322.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Glowing under blacklights",
    date: "2026-04-11",
    type: "image"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/58zaquti_20260411_145621.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Vibrant UV paint experience",
    date: "2026-04-11",
    type: "image"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/3drqgbzr_20260329_150222_003.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Fluorescent creativity unleashed",
    date: "2026-03-29",
    type: "image"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/0zce50tg_20260329_150233_005.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Stunning glow-in-the-dark art",
    date: "2026-03-29"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/49ckhw5b_20260329_145414.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Illuminated paint party magic",
    date: "2026-03-29"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/hlsllxne_20260329_145214.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Radiant neon masterpieces",
    date: "2026-03-29"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/lm0lfvup_20260329_145058.jpg.crdownload",
    title: "Neon Lights - Electric Art",
    description: "Vivid blacklight creations",
    date: "2026-03-29"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/r1ts1glb_20260228_133219.jpg",
    title: "Creative Studio Session",
    description: "Happy guests with their vibrant artwork",
    date: "2026-02-28"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/9fvecmx4_20260222_143152.jpg",
    title: "Paint & Create",
    description: "Artistic hands at work with colorful palettes",
    date: "2026-02-22",
    type: "image"
  },
  {
    id: 13,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/x9pfoayb_AmandaB.mp4",
    title: "Amanda's Creative Session",
    description: "Watch the creative process in action",
    date: "2026-03-15",
    type: "video"
  },
  {
    id: 14,
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_color-therapy-studio/artifacts/n9gjdbef_VID_20260723_170822_362.mp4",
    title: "Paint Session Highlights",
    description: "Experience the fun and creativity",
    date: "2026-07-23",
    type: "video"
  }
];

export const upcomingEvents = [];

export const pastEvents = [
  {
    id: 4,
    title: "This Year in Color - Back to School Special Event",
    date: "2026-08-15",
    time: "12:00 PM - 8:00 PM",
    duration: "8 hours",
    spots: 20,
    spotsAvailable: 0,
    description: "🎨 An all-day back-to-school paint event where students expressed themselves through art. All materials were included - a colorful start to the school year!",
    completed: true
  },
  {
    id: 100,
    title: "Leave it on the Canvas",
    date: "2026-05-16",
    time: "10:00 AM - 10:00 PM",
    duration: "All Day Event",
    spots: 15,
    spotsAvailable: 0,
    description: "🎨 Our FIRST Pop-Up Event - Saturday, May 16th, 2026! An all-day creative marathon where participants unleashed their emotions and left everything on the canvas. This event was a huge success!",
    featured: true,
    isPopup: true,
    completed: true
  }
];

export const contactSubmissions = [];

export const testimonials = [
  {
    id: 2,
    name: "Sarah R.",
    comment: "My daughter and her friends came to the splatter room for her 14th Birthday. My daughter felt it was very relaxing and enjoyed the carefree experience. She loved the colors and the options were endless. It was a great time with her pals, and they enjoyed adding music to the playlist. We will absolutely be back.",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/wqxt90hb_20260411_143444_007.jpg.crdownload",
    sessionAttended: "Birthday Party",
    date: "2026-04-10",
    approved: true
  },
  {
    id: 3,
    name: "Jocelynn M.",
    comment: "My husband covered himself when I started throwing paint 😂",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_color-therapy-studio/artifacts/pj4our0e_20260222_143152.jpg",
    sessionAttended: "Couples Paint Adventure",
    date: "2026-04-14",
    approved: true
  }
];

export const pendingTestimonials = [];

export const studioInfo = {
  name: "Rage Room with Paint",
  tagline: "Unleash Your Inner Artist",
  description: "Experience the ultimate creative release at Rage Room with Paint - where paint meets passion! Like a rage room, but with canvas and colors, our studio offers a unique space to express yourself freely through art.",
  owner: {
    name: "Crystal Roskom",
    title: "Owner"
  },
  email: "info@creativeminds-usa.com",
  phone: "(701) 561-6092",
  address: "18 1st St West Fargo, ND",
  hours: {
    weekday: "11:00 AM - 11:00 PM",
    weekend: "9:00 AM - 11:00 PM",
    note: "By Appointment Only"
  },
  social: {
    instagram: "@creativemindsstudio",
    facebook: "CreativeMindsStudio",
    tiktok: "@creativeminds",
    snapchat: "@creativeminds"
  }
};
